import { Injectable } from '@angular/core';
import { Position, PositionCreationMode } from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class DashboardHookService {
  constructor() {}

  findOpenPosition(positions: Position[]): Position {
    console.log('DashboardHookService.findOpenPosition not implemented');
    return;
  }

  findCreationMode(positions: Position[]): PositionCreationMode {
    console.log('DashboardHookService.findCreationMode not implemented');
    return;
  }

  isActionRevoked(positions: Position[]): boolean {
    console.log('DashboardHookService.isActionRevoked not implemented');
    return false;
  }
}
